import React, { useState } from 'react';
import { View } from 'react-native';
import { ThemedText } from '@/components/themed-text';
import { PressableScale } from '@/components/ui/pressable-scale';
import { useExpensesTotal } from '@/hooks/use-expenses';
import { formatCurrency } from '@/utils/format-currency';
import { format, startOfMonth, endOfMonth } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Ionicons } from '@expo/vector-icons';
import { router } from 'expo-router';
import { SkeletonSummaryCard } from '@/components/ui/skeleton';
import { HomeSummaryDialog } from '@/components/dashboard/home-summary-dialog';
import { ExpensesSummary } from '@/components/dashboard/summaries/expenses-summary';
import { useIconChip } from '@/hooks/use-theme-colors';

export function ExpensesMonthCard() {
  const chip = useIconChip();
  const [open, setOpen] = useState(false);
  const now = new Date();
  const startDate = format(startOfMonth(now), 'yyyy-MM-dd');
  const endDate = format(endOfMonth(now), 'yyyy-MM-dd');
  const { data: total, isLoading } = useExpensesTotal(startDate, endDate);

  if (isLoading) {
    return (
      <View className="w-full max-w-6xl">
        <SkeletonSummaryCard />
      </View>
    );
  }

  const monthLabel = format(now, 'MMMM yyyy', { locale: ptBR });

  return (
    <View className="w-full max-w-6xl">
      <PressableScale
        haptic
        onPress={() => setOpen(true)}
        className="flex-row items-center gap-3 rounded-2xl border border-neutral-900/5 bg-card p-4"
        style={{
          borderCurve: 'continuous',
          boxShadow: '0 1px 2px rgba(23, 17, 10, 0.04), 0 6px 16px rgba(23, 17, 10, 0.06)',
        }}
      >
        <View
          className="h-11 w-11 items-center justify-center rounded-2xl"
          style={{ backgroundColor: chip('#DC2626', '1A').bg, borderCurve: 'continuous' }}
        >
          <Ionicons color={chip('#DC2626', '1A').fg}  name="wallet-outline" size={22} />
        </View>
        <View className="flex-1">
          <ThemedText className="text-base font-bold text-neutral-900">Gastos do mês</ThemedText>
          <ThemedText className="text-xs capitalize text-neutral-500">{monthLabel}</ThemedText>
        </View>
        <ThemedText
          className="text-base font-bold text-neutral-900"
          style={{ fontVariant: ['tabular-nums'] }}
        >
          {formatCurrency(total ?? 0)}
        </ThemedText>
        <Ionicons className="text-neutral-400" name="chevron-forward" size={20} />
      </PressableScale>

      <HomeSummaryDialog
        open={open}
        onClose={() => setOpen(false)}
        icon="wallet-outline"
        title="Gastos do mês"
        subtitle={monthLabel}
        seeMoreLabel="Ver todos os gastos"
        onSeeMore={() => router.push('/(tabs)/(provider)/expenses')}
      >
        <ExpensesSummary />
      </HomeSummaryDialog>
    </View>
  );
}
